module.exports = __webpack_public_path__ + "static/media/arbitrum-network.261f0ca6.svg";